import { PdfSplitProgress } from 'editor/src/store/gallery/types';
import getHostSetting from 'editor/src/store/hostSettings/selector/getHostSetting';
import { RootState } from 'editor/src/store/index';

const NO_SPLITS: PdfSplitProgress[] = [];

// The gallery tracks splits either way, to keep their pages in upload order; the host decides whether they show.
const getPdfSplits = (state: RootState) =>
  getHostSetting(state, 'enablePdfSplitProgressAutofill') ? state.gallery.pdfSplits ?? NO_SPLITS : NO_SPLITS;

export default getPdfSplits;
